import { useEffect, useState } from "react";
import SetPassword from "./SetPassword";
import { setItem } from "../../utils/localStorageUtils";

const SetPasswordIntermediate = () => {
    const [uiid, setUiid] = useState("");

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const uiidParams = params.get("uiid");

        setItem("uiid", uiidParams)

        if (uiidParams) {
            setUiid(uiidParams)
            window.history.replaceState({}, document.title, "/set-password");
        }
    }, []);

    return <SetPassword uiid={uiid} />;
}

export default SetPasswordIntermediate;